<div
  class="w-72 bg-white rounded-xl shadow-2xl border border-outline-variant/30 z-50 overflow-hidden"
  role="menu"
>
  <div class="px-4 py-3 bg-surface-container-low border-b border-outline-variant/20 flex justify-between items-center">
    <p class="font-bold text-sm text-primary">Notificaciones</p>
    @if (unreadCount() > 0) {
      <span class="text-xs bg-primary text-on-primary px-2 py-0.5 rounded-full">{{ unreadCount() }}</span>
    }
  </div>

  <div class="divide-y divide-outline-variant/20 max-h-64 overflow-y-auto">
    @for (notification of notifications(); track notification.id) {
      <button
        type="button"
        role="menuitem"
        class="w-full text-left px-4 py-3 hover:bg-surface-container-low cursor-pointer"
        (click)="itemClick.emit(notification)"
      >
        <p class="text-sm font-semibold text-on-surface">{{ notification.title }}</p>
        <p class="text-xs text-on-surface-variant">
          @if (notification.body) {
            {{ notification.body }} ·
          }
          {{ notification.created_at | relativeTime }}
        </p>
      </button>
    } @empty {
      <p class="px-4 py-6 text-sm text-on-surface-variant text-center">No tienes notificaciones.</p>
    }
  </div>
</div>
